// /* global debounce */
// if (!customElements.get('cart-note')) {
//   class CartNote extends HTMLElement {
//     constructor() {
//       super();
//       this.disclosure = this.closest('details');

//       if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
//         this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
//       }

//       this.fetchRequestOpts = {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json'
//         }
//       };

//       this.init();
//     }

//     init() {
//       this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
//       // Save as soon as possible, avoid link-click not providing time to save
//       this.addEventListener('keyup', this.debouncedHandleNoteChange);
//       this.addEventListener('change', this.debouncedHandleNoteChange);
//     }

//     handleNoteChange(evt) {
//       if (this.cartNoteToggle) {
//         const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
//         if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
//       }

//       this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
//       fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
//     }
//   }

//   customElements.define('cart-note', CartNote);
// }




class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler.bind(this));
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  open(opener = null) {
    this.classList.add('open');
    this.dispatchEvent(new CustomEvent('on:cart-drawer:before-open', { detail: { opener } }));
  }

  close(opener = null) {
    this.classList.remove('open');
    this.dispatchEvent(new CustomEvent('on:cart-drawer:after-close', { detail: { opener } }));
  }
}

window.customElements.define('cart-drawer', CartDrawer);

